<template>
  <div id="home" :style="{ minHeight: this.$store.getters.fullWindowHeightMinusFooter }">

    <intro/>

    <!-- <html-guide/> -->

    <!-- <footer-final/> -->

    <!-- SÄÄSTÄ NÄMÄ -->
    <!-- <input type="file" @change="onFileChange">
    <button @click="onUpload">submit</button> -->

    <!-- <div>
      <img src="@/assets/2svgTESTI.svg" alt="">
    </div> -->

    <Gallery class="wrapper pb-6">
      <!-- <Gitem class="bg-theme">
        <div class="gallery-card-info">
          <h4 class="break-initial mb-1 txt-bold color-white pointer">Mikä tämä sovellus on?</h4>
        </div>
        <div class="h-1"></div>
      </Gitem> -->
      <GitemTopics
        v-for="(topic, index) in setOfTopics"
        :key="index"
        :data="topic">
      </GitemTopics>
    </Gallery>

  </div>
</template>

<script>
// import { mapState } from 'vuex'
// import axios from 'axios'
// import db from '@/firebase/init'
// import footerFinal from '@/components/footerFinal'
import intro from '@/components/intro'
import Gallery from '../components/Gallery'
import GitemTopics from '../components/GitemTopics'
// import Gitem from '../components/Gitem'

export default {
  name: 'home',

  components: {
    // footerFinal,
    intro,
    Gallery,
    GitemTopics
    // Gitem
  },

  data () {
    return {
      topics: [],
      targetFile: null
    }
  },

  created () {
    this.$store.dispatch('storeTopics')
  },

  computed: {
    setOfTopics () {
      let newSet = this.$store.state.topics.map(a => a)
      // console.log(newSet, 'newset');
      // newSet.map(a => a)
      let first = newSet.find(topic => {
        return topic.slug === 'mika-tama-sovellus-on?' // kovakoodattu :(
      })
      newSet.sort((x, y) => {
        return x === first ? -1 : y === first ? 1 : 0
      })
      return newSet
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/styles/styles.scss";

.card:first-child {
  background-color: $color-theme;
  //background-color: #302e2d;
  color: white;
  & h4:hover { color: $color-theme2; }
}
</style>
